import { css } from "@emotion/react";

export const toastifyStyles = theme => css`
  --toastify-icon-color-info: ${theme.colors.primary.dark};
  --toastify-icon-color-success: ${theme.colors.success.dark};
  --toastify-icon-color-warning: ${theme.colors.warning.dark};
  --toastify-icon-color-error: ${theme.colors.error.dark};
  width: auto;
  .non-clickable {
    cursor: default;
    > svg {
      cursor: pointer;
    }
  }
  
  .Toastify__toast {
    min-height: 56px;
    padding: 16px 10px 16px 16px;
    gap: 16px;
    margin-bottom: 0;
  }
  .Toastify__toast-icon {
    margin-inline-end: 16px;
  }
  .Toastify__toast--error {
    border: 1px solid ${theme.colors.error.dark};
    border-radius: 12px;
    background: ${theme.colors.error.ultraLight};
    color: ${theme.colors.error.dark};
    &.Toastify__toast > button {
      color: ${theme.colors.error.dark};
    }
  }
  .Toastify__toast--success {
    border: 1px solid ${theme.colors.success.dark};
    border-radius: 12px;
    background: ${theme.colors.success.ultraLight};
    color: ${theme.colors.success.dark};
    &.Toastify__toast > button {
      color: ${theme.colors.success.dark};
    }
  }
  .Toastify__toast--info {
    border: 1px solid ${theme.colors.primary.dark};
    border-radius: 12px;
    background: ${theme.colors.surface.main};
    color: ${theme.colors.primary.dark};
    &.Toastify__toast > button {
      color: ${theme.colors.primary.dark};
    }
  }
  .Toastify__toast--warning {
    border: 1px solid ${theme.colors.warning.dark};
    border-radius: 12px;
    background: ${theme.colors.warning.ultraLight};
    color: ${theme.colors.warning.dark};
    &.Toastify__toast > button {
      color: ${theme.colors.warning.dark};
    }
  }
  .Toastify__toast-body {
    font-size: ${theme.typography.body1.fontSize};
    font-weight: ${theme.typography.body1.fontWeight};
    padding: 0;
  }
  .Toastify__close-button {
    align-self: center;
    cursor: pointer;
  }
`;
